import { AxiosInstance } from 'axios'

export type QuestionEvaluationLanguage = 'en' | 'de' | 'fr' | 'it'

export interface IEvaluateQuestionBody {
  title: string
  description: string
  language: QuestionEvaluationLanguage
  maxTitleLength: number
}

export type IQuestionEvaluation =
  | { needsImprovement: false, feedback: null, rewritten: null }
  | {
      needsImprovement: true
      feedback: { whatIsMissing: string, howToImprove: string }
      rewritten: { title: string, description: string }
    }

export function questionEvaluatorApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/knowledge-engine-agent/questions'
  return {
    evaluateQuestion(body: IEvaluateQuestionBody) {
      return api.post<IQuestionEvaluation>(`${baseUrl}/evaluate`, body)
    }
  }
}
